// Compact "linked guide" row used on the University Detail page.
//
// Shows up on three tabs:
//   • Admission → "How to apply in {Country}" → /apply/:code
//   • Life       → "Explore the {City} guide"  → /cities/:slug
//   • Cost       → "See cost of living in {City}" → /cities/:slug
//
// The row is deliberately quiet (left-rule accent, no shadow) so it sits
// alongside the editorial writeup without competing with the Cost tab's
// scholarships CTA. If the target doesn't exist (no city slug, no primer
// for this country) the parent should pass `to={null}` and we render
// nothing — fail-closed per product decision.
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function RelatedGuideLink({ to, eyebrow, title, blurb, testId }) {
  if (!to || !title) return null;
  return (
    <Link
      to={to}
      data-testid={testId}
      className="group block bg-[#F3F1EC] border-l-4 border-[#7C3AED] p-5 hover:bg-[#7C3AED]/[0.04] transition-colors"
    >
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#7C3AED] mb-1">
            {eyebrow}
          </div>
          <div className="font-serif text-lg text-[#002147]">
            {title}
            <span className="inline-block ml-2 text-[#7C3AED] group-hover:translate-x-1 transition-transform">
              →
            </span>
          </div>
          {blurb && (
            <div className="mt-1 font-sans text-sm text-[#002147]/70">{blurb}</div>
          )}
        </div>
        <ArrowRight className="h-5 w-5 text-stone-300 group-hover:text-[#7C3AED] shrink-0" />
      </div>
    </Link>
  );
}
